<div class="d-flex {{isLoading ? 'justify-center' : 'justify-start'}}">
  <div class="w-606 d-flex justify-center align-items-center vh-100">
    <db-alert
      status="error"
      title="{{ 'BRANCH_CUSTOMER_PAGE.' + getAppThemeName() + '.unauthorized_alert.title' | translate }}"
      [contactIcon]="null"
    >
      <div class="text-start" [innerHTML]="'BRANCH_CUSTOMER_PAGE.' + getAppThemeName() + '.unauthorized_alert.text' | translate | keepHtml:'html'"></div>
      <div class="mt-3 text-end">
        <div class="ref-id">Reference id: {{ sessionStorage.getItem("x_request_id") }}</div>
      </div>
    </db-alert>
  </div>
</div>


